import type {
  CancelMessageWithModerationDTOType,
  CreateConversationDTOType,
  GetChatFilePresignedURLDTOType,
  GetChatFilePresignedURLResponseType,
  GetConversationsDTOType,
  GetFirstGroupMessageResponseType,
  GetFirstMnetorshipGroupMessageDTOType,
  GetTaggableUsersDTOType,
  MarkConversationAsReadDTOType,
  SendMessageDTOType,
  SendMessageWithModerationDTOType,
  TaggableUserType,
  V1ConversationType,
} from '@/features/chat/types'
import fetchClient from '@/lib/fetch'

export const V1_CONVERSATIONS_QUERY_KEY = 'conversations'
export async function getConversations(data: GetConversationsDTOType): Promise<V1ConversationType[]> {
  const params = new URLSearchParams()
  if (data.programId) {
    params.append('programId', data.programId)
  }
  if (data.conversationId) {
    params.append('conversationId', data.conversationId)
  }
  return fetchClient(`/v1/chat?${params.toString()}`, {
    method: 'GET',
  })
}

export async function createConversationMutation(data: CreateConversationDTOType): Promise<V1ConversationType> {
  return fetchClient(`/v1/chat/conversation`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function sendMessageMutation(data: SendMessageDTOType): Promise<{
  pii?: boolean
  message: any
  conversationId: string
  urlToReply?: string
}> {
  return fetchClient(`/v1/chat`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function sendMessageWithModerationMutation(data: SendMessageWithModerationDTOType): Promise<void> {
  return fetchClient(`/v1/chat/confirm-send`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function cancelMessageWithModerationMutation(data: CancelMessageWithModerationDTOType): Promise<void> {
  return fetchClient(`/v1/chat/cancel-send`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export const V1_FIRST_GROUP_MESSAGE_KEY = 'first-group-message'
export async function getFirstGroupMessage(
  data: GetFirstMnetorshipGroupMessageDTOType,
): Promise<GetFirstGroupMessageResponseType> {
  return fetchClient(
    `/v1/chat/autfill/first-mentorship-group-message?programId=${data.programId}&mentorshipGroupId=${data.mentorshipGroupId}`,
    {
      method: 'GET',
    },
  )
}

export async function markConversationAsReadMutation(data: MarkConversationAsReadDTOType): Promise<void> {
  return fetchClient(`/v1/chat/markAsRead/`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function getTaggableUsers(data: GetTaggableUsersDTOType): Promise<TaggableUserType[]> {
  const searchParam = data.search ? `&search=${encodeURIComponent(data.search)}` : ''
  return fetchClient(`/v1/chat/taggable-users?conversationId=${data.conversationId}${searchParam}`, {
    method: 'GET',
  })
}

export async function getChatFilePresignedURLMutation(
  data: GetChatFilePresignedURLDTOType,
): Promise<GetChatFilePresignedURLResponseType> {
  return fetchClient(`/v1/chat/file`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}
